import { render, staticRenderFns } from "./HeadUtils.vue?vue&type=template&id=48d87d66&"
import script from "./HeadUtils.vue?vue&type=script&lang=js&"
export * from "./HeadUtils.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports